import TopLanding, { fetch } from './TopLanding.vue'

export default TopLanding
export { fetch }
